import { render, staticRenderFns } from "./CreateAccountingEntryForm.vue?vue&type=template&id=52507276&scoped=true&"
import script from "./CreateAccountingEntryForm.vue?vue&type=script&lang=js&"
export * from "./CreateAccountingEntryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52507276",
  null
  
)

export default component.exports